import type { Feature } from '../../../../types';
import { DOMAINS_EMAIL_FEATURE_GROUP } from './group';

export const DOMAINS_EMAIL_FEATURES = {
  READ: {
    guid: 'e8f14b25-6d93-4a7c-b120-4c9f83e20000',
    name: 'domains:email:read',
    description: 'View email domains and their DNS records',
    action: 'read',
    product: 'account',
    parentGuid: DOMAINS_EMAIL_FEATURE_GROUP.guid,
  },
  CREATE: {
    guid: 'e8f14b25-6d93-4a7c-b120-4c9f83e20001',
    name: 'domains:email:create',
    description: 'Register new email domains for the organization',
    action: 'create',
    product: 'account',
    parentGuid: DOMAINS_EMAIL_FEATURE_GROUP.guid,
  },
  VALIDATE_STATUS: {
    guid: 'e8f14b25-6d93-4a7c-b120-4c9f83e20002',
    name: 'domains:email:validate_status',
    description: 'Check and refresh the validation status of an email domain',
    action: 'update',
    product: 'account',
    parentGuid: DOMAINS_EMAIL_FEATURE_GROUP.guid,
  },
  SEND_VERIFICATION_EMAIL: {
    guid: 'e8f14b25-6d93-4a7c-b120-4c9f83e20003',
    name: 'domains:email:send_verification_email',
    description: 'Send a verification email for an email domain',
    action: 'create',
    product: 'account',
    parentGuid: DOMAINS_EMAIL_FEATURE_GROUP.guid,
  },
  DELETE: {
    guid: 'e8f14b25-6d93-4a7c-b120-4c9f83e20004',
    name: 'domains:email:delete',
    description: 'Remove email domains from the organization',
    action: 'delete',
    product: 'account',
    parentGuid: DOMAINS_EMAIL_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { DOMAINS_EMAIL_FEATURE_GROUP } from './group';
